module.exports = __webpack_public_path__ + "static/media/logo.9c8fd17d.png";